import React from 'react'
import ReactDOM from 'react-dom'
import renderImage from '../../../source/importImg'
import style from './AiSelectModal.module.css'

const AI_OPTIONS = [
    { id: 'v2', label: 'AI-1 v2', src: 'ai2KitV2' },
    { id: 'v1', label: 'AI-1 v1', src: 'ai1V1Discontinued' },
]

// Both AI-1 versions continue into the same Chat / Train screen.
const AiSelectModal = ({ show, onClose, onSelect }) => {
    if (!show) return null
    return ReactDOM.createPortal(
        <div className={style.backdrop} onClick={onClose}>
            <div
                className={style.card}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-label="Select AI"
            >
                <button
                    type="button"
                    className={style.closeBtn}
                    onClick={onClose}
                    aria-label="Close"
                >
                    ✕
                </button>
                <p className={style.title}>Select AI</p>
                <div className={style.options}>
                    {AI_OPTIONS.map((opt) => (
                        <div
                            key={opt.id}
                            className={style.option}
                            onClick={() => onSelect(opt.id)}
                        >
                            <div className={style.imgWrap}>
                                <img src={renderImage(opt.src)} alt={opt.label} />
                            </div>
                            <p className={style.label}>{opt.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>,
        document.body
    )
}

export default AiSelectModal
